module.exports = __webpack_public_path__ + "img/logo_seara.0ffc5c78.png";